<template>
	<div style="padding-top: -2px; margin-top: -2px">
		<vc-select-generic
			ref="scampaign"
			autocomplete
			class="text"
			itemtext="CmpName"
			itemvalue="CmpID"
			:disabled="disabled"
			id="CmpName"
			:value="value"
			:return-object="returnObject"
			@input="input($event)"
			:config="config"
			:label="label"
			:full="full"
			:autofocus="autofocus"
			:text="text"
			:clearable="clearable"
			:noDefault="noDefault"
			:outlined="outlined"
		></vc-select-generic>
	</div>
</template>

<script>
	import _sCampaign from "@/services/General/GenCampaignService.js"

	export default {
		name: "SelectCampaign",
		props : {
			autofocus: {
				type: Boolean,
				default: false,
			},
			disabled: {
				type: Boolean,
				default: false,
			},
			clearable: {
				type: Boolean,
				default: false,
			},
			value: null,
			text: {
				type: String,
				default: ""
			},
			label: {
				type: String,
				default: "",
			},
			returnObject: {
				type: Boolean,
				default: false,
			},
			noDefault: {
				type: Boolean,
				default: false,
			},
			full: {
				type: Boolean,
				default: false,
			},

			outlined: {
				type: Boolean,
				default: true
			},
			CceLevel : {
				type : Number,
				default : 100
			}
		},
		data() {
			return {
				item: 0,
				val: "",
				items: [],
				config: {},
			}
		},
		watch: {
			value(value) {
				this.item = value;
			},
		},

		methods: {
			focus() {
				this.$refs.scampaign.focus();
			},
			input(val) {
				this.$emit("input", val);
			},
		},

		created() {
			
			this.config = {
				url: _sCampaign.getUrlSearchCampaign(),
				title: this.label,
				params: {
					 
				},
			};
		},
	}
</script>